"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: 'AppFooter',
    data: function () {
        return {
            copyRight: "Copyright \u00A9 " + new Date().getFullYear() + " Rehab for JAPAN Inc. All Rights Reserved."
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/globals/AppFooter.vue
// module id = mckl
// module chunks = 1